const DEFAULT_BACKGROUND_COLOR = '#323A42';
const WHITE_MASK = 'filter: brightness(0) invert(1);';
export function activityIconStyles(unifiedActivity) {
  const backgroundColor = unifiedActivity?.merchantImage?.backgroundColorCode || DEFAULT_BACKGROUND_COLOR;
  if (unifiedActivity?.merchantImage?.isPrerendered) {
    return {
      backgroundColor: `background-color: ${backgroundColor};`,
      border: 'border-radius: 4px;',
      size: 'width: 56px; height: 56px; padding: 0px;'
    };
  } else {
    return {
      backgroundColor: `background-color: ${backgroundColor};`,
      filter: WHITE_MASK
    };
  }
}